module.exports = __webpack_public_path__ + "static/private-cloudfront-config-6-333ed1a4e13e37a7f2147328434e95c3.png";